import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { UserStatusComponent } from './user-status/user-status.component';
import { SharedModule } from '../../shared/shared.module';
import { throwIfAlreadyLoaded } from '../helpers/module-import-guard';
import { RecommendationCountComponent } from './recommendation-count/recommendation-count.component';
import { UiModule } from '../../shared/ui/ui.module';
import { CurrentLabComponent } from './current-lab/current-lab.component';
import { NotificationsModule } from './notifications/notifications.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    SharedModule,
    UiModule,
    NotificationsModule
  ],
  exports: [HeaderComponent, SidebarComponent, ConfigurationComponent, NotificationsModule],
  declarations: [HeaderComponent,
    SidebarComponent, ConfigurationComponent, UserStatusComponent, RecommendationCountComponent, CurrentLabComponent]
})
export class TemplateModule {
  constructor( @Optional() @SkipSelf() parentModule: TemplateModule) {
    throwIfAlreadyLoaded(parentModule, 'TemplateModule');
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/template.module.ts